"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThorchainSwapper = void 0;
const caip_1 = require("@shapeshiftoss/caip");
const types_1 = require("@shapeshiftoss/types");
const api_1 = require("../../api");
const buildThorTrade_1 = require("./buildThorTrade/buildThorTrade");
const getTradeQuote_1 = require("./getThorTradeQuote/getTradeQuote");
const thorTradeApprovalNeeded_1 = require("./thorTradeApprovalNeeded/thorTradeApprovalNeeded");
const thorTradeApproveInfinite_1 = require("./thorTradeApproveInfinite/thorTradeApproveInfinite");
const getUsdRate_1 = require("./utils/getUsdRate/getUsdRate");
const thorService_1 = require("./utils/thorService");
__exportStar(require("./types"), exports);
class ThorchainSwapper {
    constructor(deps) {
        this.name = api_1.SwapperName.Thorchain;
        this.sellSupportedChainIds = {
            [types_1.KnownChainIds.EthereumMainnet]: true,
            [types_1.KnownChainIds.BitcoinMainnet]: true,
            [types_1.KnownChainIds.DogecoinMainnet]: true,
            [types_1.KnownChainIds.LitecoinMainnet]: true,
            [types_1.KnownChainIds.BitcoinCashMainnet]: true,
            [types_1.KnownChainIds.CosmosMainnet]: true,
            [types_1.KnownChainIds.ThorchainMainnet]: true,
            [types_1.KnownChainIds.AvalancheMainnet]: false,
        };
        this.buySupportedChainIds = {
            [types_1.KnownChainIds.EthereumMainnet]: true,
            [types_1.KnownChainIds.BitcoinMainnet]: true,
            [types_1.KnownChainIds.DogecoinMainnet]: true,
            [types_1.KnownChainIds.LitecoinMainnet]: true,
            [types_1.KnownChainIds.BitcoinCashMainnet]: true,
            [types_1.KnownChainIds.CosmosMainnet]: true,
            [types_1.KnownChainIds.ThorchainMainnet]: true,
            [types_1.KnownChainIds.AvalancheMainnet]: false,
        };
        this.supportedSellAssetIds = [caip_1.thorchainAssetId];
        this.supportedBuyAssetIds = [caip_1.thorchainAssetId];
        this.deps = deps;
        this.daemonUrl = deps.daemonUrl;
        this.midgardUrl = deps.midgardUrl;
        this.adapterManager = deps.adapterManager;
        this.web3 = deps.web3;
    }
    async initialize() {
        try {
            const { data: allPools } = await thorService_1.thorService.get(`${this.deps.daemonUrl}/lcd/thorchain/pools`);
            const availablePools = allPools.filter((pool) => pool.status === 'Available');
            availablePools.forEach((pool) => {
                const assetId = caip_1.adapters.poolAssetIdToAssetId(pool.asset);
                if (!assetId)
                    return;
                const { chainId } = (0, caip_1.fromAssetId)(assetId);
                this.sellSupportedChainIds[chainId] && this.supportedSellAssetIds.push(assetId);
                this.buySupportedChainIds[chainId] && this.supportedBuyAssetIds.push(assetId);
            });
        }
        catch (e) {
            throw new api_1.SwapError('[thorchainInitialize]: initialize failed to set supportedAssetIds', {
                code: api_1.SwapErrorTypes.INITIALIZE_FAILED,
                cause: e,
            });
        }
    }
    getType() {
        return api_1.SwapperType.Thorchain;
    }
    async getUsdRate({ assetId }) {
        return (0, getUsdRate_1.getUsdRate)(this.daemonUrl, assetId);
    }
    async approvalNeeded(input) {
        return (0, thorTradeApprovalNeeded_1.thorTradeApprovalNeeded)({ deps: this.deps, input });
    }
    async approveInfinite(input) {
        return (0, thorTradeApproveInfinite_1.thorTradeApproveInfinite)({ deps: this.deps, input });
    }
    async approveAmount() {
        throw new api_1.SwapError('ThorchainSwapper: approveAmount unimplemented', {
            code: api_1.SwapErrorTypes.RESPONSE_ERROR,
        });
    }
    filterBuyAssetsBySellAssetId(args) {
        const { assetIds = [], sellAssetId } = args;
        if (!this.supportedSellAssetIds.includes(sellAssetId))
            return [];
        return assetIds.filter((assetId) => this.supportedBuyAssetIds.includes(assetId) && assetId !== sellAssetId);
    }
    filterAssetIdsBySellable() {
        return this.supportedSellAssetIds;
    }
    async buildTrade(input) {
        return (0, buildThorTrade_1.buildTrade)({ deps: this.deps, input });
    }
    async getTradeQuote(input) {
        return (0, getTradeQuote_1.getThorTradeQuote)({ deps: this.deps, input });
    }
    async executeTrade(args) {
        try {
            const { trade, wallet } = args;
            const adapter = this.deps.adapterManager.get(trade.sellAsset.chainId);
            if (!adapter)
                throw new api_1.SwapError('[executeTrade]: no adapter for sell asset chain id', {
                    code: api_1.SwapErrorTypes.SIGN_AND_BROADCAST_FAILED,
                    details: { chainId: trade.sellAsset.chainId },
                    fn: 'executeTrade',
                });
            const { chainNamespace } = (0, caip_1.fromAssetId)(trade.sellAsset.assetId);
            if (chainNamespace === caip_1.CHAIN_NAMESPACE.Evm) {
                const evmAdapter = adapter;
                const txToSign = trade.txData;
                if (wallet.supportsBroadcast()) {
                    const tradeId = await evmAdapter.signAndBroadcastTransaction({ txToSign, wallet });
                    return { tradeId };
                }
                const signedTx = await evmAdapter.signTransaction({ txToSign, wallet });
                const tradeId = await adapter.broadcastTransaction(signedTx);
                return { tradeId };
            }
            else if (chainNamespace === caip_1.CHAIN_NAMESPACE.Utxo) {
                const signedTx = await adapter.signTransaction({
                    txToSign: trade.txData,
                    wallet,
                });
                const txid = await adapter.broadcastTransaction(signedTx);
                return { tradeId: txid };
            }
            else if (chainNamespace === caip_1.CHAIN_NAMESPACE.CosmosSdk) {
                const signedTx = await adapter.signTransaction({
                    txToSign: trade.txData,
                    wallet,
                });
                const txid = await adapter.broadcastTransaction(signedTx);
                return { tradeId: txid };
            }
            else {
                throw new api_1.SwapError('[executeTrade]: unsupported trade', {
                    code: api_1.SwapErrorTypes.SIGN_AND_BROADCAST_FAILED,
                    fn: 'executeTrade',
                });
            }
        }
        catch (e) {
            if (e instanceof api_1.SwapError)
                throw e;
            throw new api_1.SwapError('[executeTrade]: failed to sign or broadcast', {
                code: api_1.SwapErrorTypes.SIGN_AND_BROADCAST_FAILED,
                cause: e,
            });
        }
    }
    async getTradeTxs(tradeResult) {
        var _a, _b, _c, _d;
        try {
            const midgardTxid = tradeResult.tradeId.startsWith('0x')
                ? tradeResult.tradeId.slice(2)
                : tradeResult.tradeId;
            const { data } = await thorService_1.thorService.get(`${this.deps.midgardUrl}/actions?txid=${midgardTxid}`);
            // https://gitlab.com/thorchain/thornode/-/blob/develop/common/tx.go#L22
            // responseData?.actions[0].out[0].txID should be the txId for consistency, but the outbound Tx for Thor rune swaps is actually a BlankTxId
            // so we use the buyTxId for completion detection
            const buyTxid = ((_a = data === null || data === void 0 ? void 0 : data.actions[0]) === null || _a === void 0 ? void 0 : _a.status) === 'success' && ((_b = data === null || data === void 0 ? void 0 : data.actions[0]) === null || _b === void 0 ? void 0 : _b.type) === 'swap'
                ? midgardTxid
                : '';
            // This will detect all the errors I have seen.
            if (((_c = data === null || data === void 0 ? void 0 : data.actions[0]) === null || _c === void 0 ? void 0 : _c.status) === 'success' && ((_d = data === null || data === void 0 ? void 0 : data.actions[0]) === null || _d === void 0 ? void 0 : _d.type) !== 'swap')
                throw new api_1.SwapError('[getTradeTxs]: trade failed', {
                    code: api_1.SwapErrorTypes.TRADE_FAILED,
                    cause: data,
                });
            const standardBuyTxid = (() => {
                var _a, _b, _c;
                const outCoinAsset = (_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.actions[0]) === null || _a === void 0 ? void 0 : _a.out[0]) === null || _b === void 0 ? void 0 : _b.coins[0]) === null || _c === void 0 ? void 0 : _c.asset;
                const isEvmCoinAsset = (outCoinAsset === null || outCoinAsset === void 0 ? void 0 : outCoinAsset.startsWith('ETH.')) || (outCoinAsset === null || outCoinAsset === void 0 ? void 0 : outCoinAsset.startsWith('AVAX.'));
                return isEvmCoinAsset ? `0x${buyTxid}` : buyTxid;
            })().toLowerCase();
            return {
                sellTxid: tradeResult.tradeId,
                buyTxid: standardBuyTxid,
            };
        }
        catch (e) {
            if (e instanceof api_1.SwapError)
                throw e;
            throw new api_1.SwapError('[getTradeTxs]: error', {
                code: api_1.SwapErrorTypes.GET_TRADE_TXS_FAILED,
                cause: e,
            });
        }
    }
}
exports.ThorchainSwapper = ThorchainSwapper;
